import type { Theme, Components } from '@mui/material/styles';

import { listClasses } from '@mui/material/List';

import { motion } from '../../motion';

// ----------------------------------------------------------------------

const MuiPopover: Components<Theme>['MuiPopover'] = {
  // ▼▼▼▼▼▼▼▼ ⚙️ PROPS ▼▼▼▼▼▼▼▼
  // MUI Popover uses Grow (already origin-aware — scales from the trigger);
  // we only tune the timing onto our tokens. Exit faster than enter.
  defaultProps: {
    transitionDuration: { enter: motion.durationMs.fast, exit: motion.durationMs.instant },
    TransitionProps: { easing: motion.ease.out },
  },
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    paper: ({ theme }) => ({
      ...theme.mixins.paperStyles(theme, { dropdown: true }),
      [`& .${listClasses.root}`]: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    }),
  },
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const popover: Components<Theme> = {
  MuiPopover,
};
